<template lang="pug">
  section(id="other")
    .goscontainer
      v-row.heading(no-gutters)
        v-col(cols=12 md=10)
          .path Наши программные решения > 
            span Сервис {{feature.title}}
          .titl {{feature.title}}
          .txt(v-html="feature.text")
          .note(v-html="feature.note")
        v-col.align-content-end.justify-content-between(cols=12 md=2 v-if="alias=='usz' || alias=='zsd'")
          v-img.up.ml-auto( :src="require(`@/assets/img/page/box-${alias}.svg`)" max-width="170")

      .panel.pa-4 
        v-row(no-gutters)
          v-col(cols="12" md="auto")
            v-img.mx-auto(:src="require(`@/assets/img/page/${alias}.svg`)" max-width="458" max-height="458")
          v-col.ml-6.mt-6.mt-md-0
            .subtitle Возможности СЕРВИСА:
            ul(v-html="feature.scope")
            .subtitle Эффекты от внедрения:
            ul(v-html="feature.eff")
            
</template>

<script>
  export default {
    name: 'Other',
    props: {
      alias: null
    },
    data: () => ({
      features: [
        {
          title: 'Удаленное судебное заседание',
          text: 'Сервис позволяет организовывать и проводить судебные заседания с участием сторон по удаленной связи (аудио и видео-трансляции) с использованием сети интернет.',
          note: '',
          scope: '<li> Модуль доступен на любом браузере в телефоне, планшете или стационарном компьютере с камерой, микрофоном и выходом в сеть интернет.'+
                 '<li> Отсутствие необходимости в установке дополнительного программного обеспечения или специального оборудования.                       '+
                 '<li> Обмен файлами (документами, изображениями) с участниками в процессе проведения заседания                                           '+
                 '<li> Контроль процесса видео-заседания со стороны судьи (отключение видео/звука, включение/исключение участников и др.)                 '+
                 '<li> Подключение дополнительных камер и демонстрация экрана компьютера или вкладки браузера                                             '+
                 '<li> Встроенное шифрование данных средствами защищенного протокола.                                                                     '+
                 '<li> Возможность автономного использования с целями проведения видео-сессий с необходимостью подтверждения личности собеседника.        ',
          eff:'<li> Непрерывная работа судов в условиях пандемии.            '+ 
              '<li> Экономия времени и ресурсов для всех участников процесса.',
          link: 'usz',
        },
        {
          title: 'Заказ судебных документов',
          text: 'Сервис, позволяющий гражданам, организациям, а также профессиональным участникам судебного процесса заказывать и получать документы в канцелярии суда через интернет не выходя из дома.',
          note: '',
          scope: '<li> Дистанционная запись на получение копий документов от канцелярии суда.                                                                                                                         '+
                 '<li> Отслеживание статуса заявки в режиме онлайн.                                                                                                                                                   '+
                 '<li> Сервис предназначен абсолютно для всех категорий участников процесса (стороны по делу, адвокаты, эксперты, переводчики, граждане РФ, представители государственных и коммерческих учреждений). '+
                 '<li> Получение документов происходит в следующих вариантах: личное вручение, отсылка на e-mail, отправка и вручение через сервис Почты России.                                                      ',
          eff:'<li> Резкое сокращение количества личных и телефонных обращений граждан с целью получения из суда копий судебных актов.         '+ 
              '<li> Граждане самостоятельно в интернете отслеживают ход исполнения своей заявки.                                               '+
              '<li> Копии судебных актов для граждан готовятся заблаговременно.                                                                '+
              '<li> Позволяет значительно сократить время выдачи уже готового судебного акта.                                                  '+
              '<li> Председатель суда со своего рабочего места может проконтролировать работу канцелярии по своевременному изготовлению копий. '+
              '<li> Оптимизация работы канцелярии суда.                                                                                        '+
              '<li> Сервис прост и понятен в использовании.                                                                                    ',
          link: 'zsd',
        },
        {
          title: 'Заявки адвоката',
          text: 'Сервис для приема и обработки заявок по оплате процессуальных издержек для экспертов, переводчиков и адвокатов.',
          note: '* Является элементом экосистемы “СУДПОРТАЛ”. В комплект поставки входит модуль “УПРАВЛЕНИЕ ДЕЛАМИ”.',
          scope: '<li> Адвокат может оформить и отправить заявление на оплату своих услуг в суд                               '+
                 '<li> Судья может вынести постановление об оплате, изменить запрошенную цену                                 '+
                 '<li> Заявка автоматически встает в очередь на оплату                                                        '+
                 '<li> По прошествии срока обжалования заявка оплачивается, после подтверждения бухгалтера департамента       '+
                 '<li> Адвокат или адвокатское образование видит все статусы заявки на оплату                                 '+
                 '<li> Модуль интегрирован с 1С судебного департамента                                                        '+
                 '<li> Сервис позволяет однозначным образом верифицировать адвоката в соответствии с профессиональным реестром',
          eff:'<li> Экономия времени на процедуру согласования вознаграждения для адвоката                                         '+ 
              '<li> Отсутствие необходимости личного присутствия, равно как и отсутствие в необходимости бумажного документооборота'+
              '<li> Все оплаты проходят в автоматическом режиме, без дополнительных согласований                                   ',
          link: 'za',
        },
        {
          title: 'ФСИН',
          text: 'Сервис электронной логистики расписок, конвоирок между структурами судебно-исполнительной системы ',
          note: '* Является элементом экосистемы “СУДПОРТАЛ”. В комплект поставки входит модуль “УПРАВЛЕНИЕ ДЕЛАМИ”.',
          scope: '<li> Позволяет оформлять судебные поручения на конвоирование, а также расписки с участников процесса по делу                                         '+
                 '<li> Модуль предусматривает навигацию документооборота между судом, ФСИН и полком конвоирования                                                      '+
                 '<li> Электронное подтверждение получения поручений из суда, он-лайн отсылка готовности к исполнению                                                  '+
                 '<li> Электронная отсылка расписок и автоматический перевод и обратная высылка подписанных сканов                                                     '+
                 '<li> Отправка документов с использованием ключей шифрования                                                                                          '+
                 '<li> Электронная идентификация документа посредством генерации QR-кода и автоматическое определение дальнейшей пересылки документа на е-мейл адресата'+
                 '<li> Для коммуникации с ФСИН и полком конвоирования используется только канал электронной почты, через специальную программу на MS Windows или Linux ',
          eff:'<li> Бесперебойная работа суда при рассмотрении дела                                                                                                              '+ 
              '<li> Экономия бюджетов на операции логистики бумажного документооборота между подразделениями                                                                     '+
              '<li> Сокращение расходов на содержание штата водителей-курьеров в судах, а также на сопутствующие процессы управления и контроля службы доставки                  '+
              '<li> Существенная экономия времени доставки поручений и расписок, наряду с сокращением времени реакции на запросы суда                                            '+
              '<li> Оперативность обмена информацией на основе средств информационной защиты, что приводит к снижению риска утечки информации при традиционных способах доставки '+
              '<li> Наличие личного кабинета СИЗО и Спецполка - позволяет избежать задвоение и некорректность информации, присутствующие на бумажных носителях.                  ',
          link: 'fsin',
        },
      ],
    }),
    computed: {
      feature () {
        return this.features.find(el => el.link==this.alias)
      }
    }
  }
</script>

<style lang="sass" scoped>
  #other
    padding: 16px 
    background-color: #FFFFFF
    color: #000000
    .heading 
      padding: 16px 0
      .up
        margin-bottom:-47px
      .path 
        color: #505254
        font-size: 12px
        line-height: 32px
        span
          color: #959595
      .titl
        font-weight: bold
        font-size: 36px
        line-height: 48px
        text-transform: uppercase
        color: #0E9DBC
        margin-bottom: 24px
      .txt
        font-size: 18px
        line-height: 24px
      .note
        font-size: 14px
        line-height: 24px
        color: #0E9DBC
    .panel
      margin-top: 8px
      background-color: #FFF
      box-shadow: 0 .2rem 1rem rgba(0, 0 , 0, .15)
      .subtitle
        font-weight: bold
        font-size: 18px
        line-height: 22px
        color: #0E9DBC
      ul
        margin-bottom: 24px
        font-size: 14px
        line-height: 22px

  @media (max-width: 960px) 
    #other
      .heading 
        .up
          display: none

</style>